import {CACHE_DURATION_MEMORY, CACHE_DURATION_PERSISTENT} from "../constants";

export const ServiceNames = [
    'addpermission',
    'addsyncstep',
    'apilogin',
    'bankidseauth',
    'changepassword',
    'checkforupdates',
    'createcompany',
    'createcompanyidp',
    'createcompanysyncstep',
    'createcompanysyncstepfilter',
    'createcompanysyncstepparameter',
    'createexportflow',
    'createexporttemplate',
    'createfeedback',
    'createformtemplate',
    'createmessage',
    'createobject',
    'createobjectanchor',
    'createoverride',
    'createrole',
    'createrule',
    'createruleset',
    'createsyncfield',
    'createsyncfielddisplayname',
    'createsystem',
    'createtenantgroup',
    'deletecompany',
    'deletecompanyidp',
    'deletecompanysyncstep',
    'deletecompanysyncstepfilter',
    'deletecompanysyncstepparameter',
    'deleteexportflow',
    'deleteexportqueue',
    'deleteexporttemplate',
    'deleteformtemplate',
    'deletelastsynccycle',
    'deletelastsyncstep',
    'deletemessage',
    'deleteobject',
    'deleteobjectanchor',
    'deleteoverride',
    'deleterole',
    'deleterule',
    'deleteruleset',
    'deletesyncfield',
    'deletesyncfielddisplayname',
    'deletesystem',
    'deletetenantgroup',
    'emptycache',
    'emptycacheaftersync',
    'emptycachecompany',
    'emulatelogin',
    'evaluateexpression',
    'evaluateformdata',
    'evaluaterule',
    'executesyncstep',
    'federatedlogin',
    'federatedloginidporten',
    'forgotpassword',
    'forgotpasswordidporten',
    'forgotpasswordnew',
    'formlogin',
    'fullexport',
    'fullobjectexport',
    'generatepassword',
    'previewcompanyidpmetadata',
    'getallcompanysyncstepparameters',
    'getauditerrorlog',
    'getauthenticationtypes',
    'getazureadteamchannels',
    'getazureadteams',
    'getcachedetails',
    'getclientcredentialprofile',
    'getclientfiles',
    'getcompany',
    'getcompanyidps',
    'getcompanylogin',
    'getcompanysyncstepparameterkeyvalues',
    'getcompanysyncsteps',
    'getconditions',
    'geteadmstatus',
    'getehubauthenticationtypes',
    'getehubprocess',
    'getexportattributes',
    'getexporttemplate',
    'getfiles',
    'getform',
    'getformauthentication',
    'getformtemplate',
    'getimportfile',
    'getimportformats',
    'getimporthrfile',
    'getimportlogfile',
    'getimportorgfile',
    'getlanguages',
    'getmessage',
    'getmessagetypes',
    'getmessagevariables',
    'getobject',
    'getobjectattributevalues',
    'getobjecttypes',
    'getoperators',
    'getorganizationchart',
    'getruleset',
    'getserverfunctionelementitems',
    'getstatuscodes',
    'getsyncexportqueue',
    'getsyncfields',
    'getsyncsteps',
    'getsyncstepstandardmappings',
    'gettestintegrations',
    'gettenantgroups',
    'getuniquefieldvalues',
    'getusernamegenerationrules',
    'getuserpasswordgenerationrules',
    'identifyhubspotcontact',
    'importp360roles',
    'importsystemrolepermissions',
    'login',
    'logout',
    'partialexport',
    'postform',
    'purgeimporteddata',
    'purgeobject',
    'purgesystemrolepermissions',
    'purgetestdata',
    'recreateobject',
    'requesttemporaryaccesspass',
    'resetpassword',
    'resetpasswordbysms',
    'resettodefaultpassword',
    'resettodefaultpasswordbyid',
    'restoreoverride',
    'resumesynccycle',
    'schedulesync',
    'searchauditlog',
    'searchauditlogerror',
    'searchauditlogsecurity',
    'searchexporttemplate',
    'searchformtemplate',
    'searchgroupmember',
    'searchimporthrfile',
    'searchmessage',
    'searchmessagelog',
    'searchobject',
    'searchobjecthistory',
    'searchruleset',
    'searchsystem',
    'sendallmessages',
    'sendendreport',
    'sendmessage',
    'testcompanyidplogin',
    'testexportP360',
    'testimportfile',
    'triggertestintegration',
    'updatecompany',
    'updatecompanyidp',
    'updatecompanysyncstep',
    'updatecompanysyncstepfilter',
    'updatecompanysyncstepparameter',
    'updateexportflow',
    'updateexporttemplate',
    'updateformtemplate',
    'updatemanualobjectfield',
    'updatemessage',
    'updateobject',
    'updateobjectanchor',
    'updateobjectfield',
    'updateoverridecomment',
    'updatepasswordpolicy',
    'updatepermission',
    'updatereceivedmessage',
    'updaterole',
    'updaterule',
    'updateruleset',
    'updatesyncfield',
    'updatesyncfielddisplayname',
    'updatesystem',
    'updatetenantgroup',
] as const;
export type TServiceName = typeof ServiceNames[number];

export const ServiceParams: Record<TServiceName, readonly string[]> = {
    'addpermission':                        ['objectid', 'systemroleid', 'expirydate', 'departmentid', 'comment', 'orgnr', 'token'],
    'addsyncstep':                          ['id', 'orgnr', 'token'],
    'apilogin':                             ['orgid', 'username', 'password'],
    'bankidseauth':                         ['orgnr', 'orderref'],
    'changepassword':                       ['token', 'id', 'orgnr', 'newpassword', 'oldpassword'],
    'checkforupdates':                      ['orgnr', 'token'],
    'createcompany':                        ['jcompany', 'orgnr', 'token'],
    'createcompanyidp':                     ['token', 'orgnr', 'protocol', 'displayname', 'metadataxml', 'metadataurl', 'claimmapping', 'wantassertionsigned', 'wantresponsesigned', 'allowclockskewminutes', 'isenabled', 'primary'],
    'createcompanysyncstep':                ['token', 'companysyncstep', 'orgnr'],
    'createcompanysyncstepfilter':          ['token', 'companysyncstepfilter', 'orgnr'],
    'createcompanysyncstepparameter':       ['token', 'companysyncstepparameter', 'orgnr'],
    'createexportflow':                     ['exporttemplateid', 'jexportflow', 'orgnr', 'token'],
    'createexporttemplate':                 ['jexporttemplate', 'orgnr', 'token'],
    'createfeedback':                       ['token', 'orgnr', 'feedback', 'satisfaction'],
    'createformtemplate':                   ['jformtemplate', 'orgnr', 'token'],
    'createmessage':                        ['jmessage', 'orgnr', 'token'],
    'createobject':                         ['jobject', 'orgnr', 'token'],
    'createobjectanchor':                   ['token', 'janchor', 'orgnr'],
    'createoverride':                       ['joverride', 'orgnr', 'token'],
    'createrole':                           ['token', 'jrole', 'orgnr'],
    'createrule':                           ['rulesetid', 'jrule', 'orgnr', 'token'],
    'createruleset':                        ['jruleset', 'orgnr', 'token'],
    'createsyncfield':                      ['jsyncfield', 'orgnr', 'token'],
    'createsyncfielddisplayname':           ['jdisplayname', 'orgnr', 'token'],
    'createsystem':                         ['token', 'jsystem', 'orgnr'],
    'createtenantgroup':                    ['token', 'name'],
    'deletecompany':                        ['id', 'orgnr', 'token'],
    'deletecompanyidp':                     ['token', 'orgnr', 'id'],
    'deletecompanysyncstep':                ['token', 'companysyncstep', 'orgnr'],
    'deletecompanysyncstepfilter':          ['token', 'companysyncstepfilterid', 'orgnr'],
    'deletecompanysyncstepparameter':       ['token', 'companysyncstepparameterid', 'orgnr'],
    'deleteexportflow':                     ['id', 'orgnr', 'token'],
    'deleteexportqueue':                    ['id', 'orgnr', 'token'],
    'deleteexporttemplate':                 ['id', 'orgnr', 'token'],
    'deleteformtemplate':                   ['id', 'orgnr', 'token'],
    'deletelastsynccycle':                  ['id', 'orgnr', 'token'],
    'deletelastsyncstep':                   ['id', 'orgnr', 'token'],
    'deletemessage':                        ['id', 'orgnr', 'token'],
    'deleteobject':                         ['id', 'orgnr', 'token'],
    'deleteobjectanchor':                   ['token', 'id', 'orgnr'],
    'deleteoverride':                       ['token', 'id', 'orgnr'],
    'deleterole':                           ['token', 'id', 'orgnr'],
    'deleterule':                           ['token', 'id', 'orgnr'],
    'deleteruleset':                        ['token', 'id', 'orgnr'],
    'deletesyncfield':                      ['token', 'id', 'orgnr'],
    'deletesyncfielddisplayname':           ['token', 'id', 'orgnr'],
    'deletesystem':                         ['token', 'id', 'orgnr'],
    'deletetenantgroup':                    ['token', 'id', 'orgnr'],
    'emptycache':                           ['token', 'orgnr'],
    'emptycacheaftersync':                  ['token', 'orgnr', 'importfileid', 'objecttypeid'],
    'emptycachecompany':                    ['token', 'orgnr'],
    'emulatelogin':                         ['token', 'userid', 'orgnr'],
    'evaluateexpression':                   ['orgnr', 'token', 'objectid', 'expression'],
    'evaluateformdata':                     ['orgnr', 'targetid', 'id', 'token', 'sourceelement', 'targetelement', 'preview'],
    'evaluaterule':                         ['orgnr', 'token', 'formdata', 'rc'],
    'executesyncstep':                      ['id', 'orgnr', 'token', 'ispartoffullsync', 'runscriptblock'],
    'federatedlogin':                       ['id', 'tenantid', 'secret'],
    'federatedloginidporten':               ['id', 'tenantid', 'secret'],
    'forgotpassword':                       ['orgnr', 'mobile', 'username', 'nin', 'captchacode'],
    'forgotpasswordidporten':               ['orgnr', 'username', 'nin', 'secret'],
    'forgotpasswordnew':                    ['verificationfields', 'orgnr', 'captchacode'],
    'formlogin':                            ['orgid', 'username', 'password', 'captchacode'],
    'fullexport':                           ['orgnr', 'companysyncstepid', 'test', 'token', 'objecttypeid'],
    'fullobjectexport':                     ['orgnr', 'objecttypeid', 'objectid', 'syncstepid', 'test', 'token'],
    'generatepassword':                     ['token', 'orgnr', 'nr'],
    'previewcompanyidpmetadata':            ['token', 'orgnr', 'protocol', 'metadataxml', 'metadataurl'],
    'getallcompanysyncstepparameters':      ['token', 'companysyncstepid', 'orgnr'],
    'getauditerrorlog':                     ['token', 'orgnr', 'registeredby', 'objectid', 'errorid'],
    'getauthenticationtypes':               [],
    'getazureadteamchannels':               ['token', 'id', 'orgnr'],
    'getazureadteams':                      ['token', 'orgnr'],
    'getcachedetails':                      [],
    'getclientcredentialprofile':           ['token', 'orgnr', 'syncstepid'],
    'getclientfiles':                       ['token', 'orgnr'],
    'getcompany':                           ['token', 'orgnr'],
    'getcompanylogin':                      [],
    'getcompanyidps':                       ['token', 'orgnr'],
    'getcompanysyncstepparameterkeyvalues': ['token', 'orgnr', 'syncstepid'],
    'getcompanysyncsteps':                  ['token', 'orgnr'],
    'getconditions':                        ['token', 'orgnr'],
    'geteadmstatus':                        ['token'],
    'getehubauthenticationtypes':           ['formid'],
    'getehubprocess':                       ['token', 'orgnr'],
    'getexportattributes':                  ['token', 'orgnr', 'syncstepid', 'objecttypeid'],
    'getexporttemplate':                    ['token', 'id', 'orgnr'],
    'getfiles':                             ['id', 'filepath', 'token', 'orgnr'],
    'getform':                              ['token', 'id', 'targetid', 'orgnr', 'preview'],
    'getformauthentication':                ['id', 'orgnr'],
    'getformtemplate':                      ['token', 'id', 'orgnr'],
    'getimportfile':                        ['id', 'orgnr', 'token'],
    'getimportformats':                     ['token'],
    'getimporthrfile':                      ['token', 'importfileid', 'orgnr'],
    'getimportlogfile':                     ['id', 'orgnr', 'token'],
    'getimportorgfile':                     ['id', 'orgnr', 'token'],
    'getlanguages':                         ['token'],
    'getmessage':                           ['token', 'id', 'orgnr'],
    'getmessagetypes':                      ['token', 'orgnr'],
    'getmessagevariables':                  ['objecttypeid', 'token', 'orgnr'],
    'getobject':                            ['token', 'id', 'manual', 'orgnr'],
    'getobjectattributevalues':             ['token', 'attributename', 'objecttypeid', 'orgnr'],
    'getobjecttypes':                       ['token', 'orgnr'],
    'getoperators':                         ['token', 'orgnr'],
    'getorganizationchart':                 ['orgnr', 'token'],
    'getruleset':                           ['token', 'id', 'orgnr'],
    'getserverfunctionelementitems':        ['token', 'orgnr'],
    'getstatuscodes':                       ['token'],
    'getsyncexportqueue':                   ['token', 'orgnr'],
    'gettestintegrations':                  ['orgnr', 'token'],
    'getsyncfields':                        ['token', 'orgnr', 'objecttypeid', 'importformatid', 'languageid'],
    'getsyncsteps':                         ['token'],
    'getsyncstepstandardmappings':          ['objecttypeid', 'syncstepid', 'orgnr', 'token'],
    'gettenantgroups':                      ['token'],
    'getuniquefieldvalues':                 ['token', 'orgnr', 'fieldname'],
    'getusernamegenerationrules':           ['token'],
    'getuserpasswordgenerationrules':       ['token'],
    'identifyhubspotcontact':               ['token', 'preferredlanguage'],
    'importp360roles':                      ['token', 'id', 'test', 'orgnr'],
    'importsystemrolepermissions':          ['token', 'orgnr', 'syncstep', 'objectdata', 'systemroleid', 'pkname'],
    'login':                                ['token'],
    'logout':                               ['token'],
    'partialexport':                        ['orgnr', 'exportflows', 'objecttypeid', 'objectids', 'test', 'token'],
    'postform':                             ['token', 'id', 'targetid', 'formdata', 'orgnr', 'html'],
    'purgeimporteddata':                    ['orgnr', 'token'],
    'purgeobject':                          ['id', 'orgnr', 'token'],
    'purgesystemrolepermissions':           ['token', 'orgnr', 'systemroleid', 'includeoverrides'],
    'purgetestdata':                        ['token'],
    'recreateobject':                       ['id', 'orgnr', 'token'],
    'requesttemporaryaccesspass':            ['token', 'id'],
    'resetpassword':                        ['token', 'id', 'orgnr', 'newpassword'],
    'resetpasswordbysms':                   ['token', 'id', 'orgnr', 'mobilefield'],
    'resettodefaultpassword':               ['token', 'orgnr'],
    'resettodefaultpasswordbyid':           ['token', 'orgnr', 'objectid'],
    'restoreoverride':                      ['token', 'id', 'orgnr'],
    'resumesynccycle':                      ['id', 'orgnr', 'token'],
    'schedulesync':                         ['csseid', 'token', 'orgnr'],
    'searchauditlog':                       ['token', 'searchkey', 'resultsprpage', 'pagenr', 'orgnr', 'sortcol', 'asc', 'fromdate', 'todate'],
    'searchauditlogerror':                  ['token', 'searchkey', 'resultsprpage', 'pagenr', 'orgnr', 'sortcol', 'asc', 'fromdate', 'todate'],
    'searchauditlogsecurity':               ['token', 'searchkey', 'resultsprpage', 'pagenr', 'orgnr', 'sortcol', 'asc', 'fromdate', 'todate'],
    'searchexporttemplate':                 ['token', 'searchkey', 'resultsprpage', 'pagenr', 'orgnr', 'sortcol', 'asc'],
    'searchformtemplate':                   ['token', 'searchkey', 'resultsprpage', 'pagenr', 'orgnr', 'sortcol', 'asc'],
    'searchgroupmember':                    ['token', 'objectid', 'searchkey', 'resultsprpage', 'pagenr', 'orgnr', 'sortcol', 'searchcols', 'asc'],
    'searchimporthrfile':                   ['token', 'searchkey', 'resultsprpage', 'pagenr', 'orgnr', 'sortcol', 'asc'],
    'searchmessage':                        ['token', 'searchkey', 'resultsprpage', 'pagenr', 'orgnr', 'sortcol', 'asc'],
    'searchmessagelog':                     ['token', 'messageid', 'searchkey', 'resultsprpage', 'pagenr', 'orgnr', 'sortcol', 'asc', 'fromdate', 'todate'],
    'searchobject':                         ['token', 'objecttypeid', 'searchkey', 'resultsprpage', 'pagenr', 'orgnr', 'sortcol', 'asc', 'searchcols', 'manualobjects', 'onlytuples', 'jruleset', 'onlyids', 'syncstep', 'deleted', 'importfileid', 'syncfieldids'],
    'searchobjecthistory':                  ['token', 'objectid', 'searchkey', 'resultsprpage', 'pagenr', 'orgnr', 'sortcol', 'searchcols', 'asc',],
    'searchruleset':                        ['token', 'searchkey', 'resultsprpage', 'pagenr', 'orgnr', 'sortcol', 'asc'],
    'searchsystem':                         ['token', 'targetid', 'searchkey', 'resultsprpage', 'pagenr', 'orgnr', 'sortcol', 'asc', 'skipsystemavailableto'],
    'sendallmessages':                      ['historyid', 'orgnr', 'token', 'messageids'],
    'sendendreport':                        ['token', 'orgnr', 'importfile'],
    'sendmessage':                          ['messageid', 'token', 'orgnr', 'targetobjectid'],
    'testexportP360':                       ['token', 'id', 'orgnr'],
    'testimportfile':                       ['token', 'id', 'orgnr'],
    'triggertestintegration':               ['orgnr', 'syncstepid', 'token'],
    'updatecompany':                        ['jcompany', 'orgnr', 'token'],
    'updatecompanyidp':                     ['token', 'orgnr', 'id', 'displayname', 'metadataxml', 'metadataurl', 'claimmapping', 'wantassertionsigned', 'wantresponsesigned', 'allowclockskewminutes', 'isenabled', 'primary'],
    'updatecompanysyncstep':                ['token', 'companysyncstep', 'orgnr'],
    'updatecompanysyncstepfilter':          ['token', 'companysyncstepfilter', 'orgnr'],
    'updatecompanysyncstepparameter':       ['token', 'companysyncstepparameter', 'orgnr'],
    'updateexportflow':                     ['jexportflow', 'orgnr', 'token'],
    'updateexporttemplate':                 ['jexporttemplate', 'orgnr', 'token'],
    'updateformtemplate':                   ['jformtemplate', 'orgnr', 'token'],
    'updatemanualobjectfield':              ['id', 'value', 'fieldid', 'orgnr', 'token',],
    'updatemessage':                        ['jmessage', 'orgnr', 'token'],
    'updateobject':                         ['jobject', 'orgnr', 'token'],
    'updateobjectanchor':                   ['token', 'janchor', 'orgnr'],
    'updateobjectfield':                    ['objectid', 'fieldname', 'value', 'orgnr', 'token'],
    'updateoverridecomment':                ['id', 'comment', 'orgnr', 'token'],
    'updatepasswordpolicy':                 ['id', 'orgnr', 'token'],
    'updatepermission':                     ['jobject', 'orgnr', 'token'],
    'updatereceivedmessage':                ['id', 'completed', 'read', 'orgnr', 'token'],
    'updaterole':                           ['token', 'jrole', 'orgnr'],
    'updaterule':                           ['jrule', 'orgnr', 'token'],
    'updateruleset':                        ['jruleset', 'orgnr', 'token'],
    'updatesyncfield':                      ['jsyncfield', 'orgnr', 'token'],
    'updatesyncfielddisplayname':           ['jdisplayname', 'orgnr', 'token'],
    'testcompanyidplogin':                  ['token', 'orgnr', 'id'],
    'updatesystem':                         ['token', 'jsystem', 'orgnr'],
    'updatetenantgroup':                    ['jtenantgroup', 'orgnr', 'token'],
} as const;

export type TServiceParameter = typeof ServiceParams[keyof typeof ServiceParams][number];

export const OptionalParams: Partial<Record<TServiceName, readonly TServiceParameter[]>> = {
    'evaluateformdata':                     ['preview'],
    'getorganizationchart':                 ['token'],
    'getsyncfields':                        ['token'], // optional; without token it responds with core-only fields - with token it responds with all fields
} as const;

export const getServiceDefinition = function (serviceName: TServiceName): TServiceDefinition {
    return {
        cache: getCacheType(serviceName) ?? {type: null},
        name: serviceName,
        paramKeys: ServiceParams[serviceName],
    }
}

const getCacheType = function (serviceName: TServiceName): TServiceCache {
    switch (serviceName) {
        case 'getcompany':
            return {type: 'memory', duration: 60 * 1000} // 1 min
        case 'getallcompanysyncstepparameters':
        case 'getauthenticationtypes':
        case 'getcompanylogin':
        case 'getcompanysyncstepparameterkeyvalues':
        case 'getclientcredentialprofile':
        case 'getcompanysyncsteps':
        case 'geteadmstatus':
        case 'getexporttemplate':
        case 'getformtemplate':
        case 'getimportformats':
        case 'getimporthrfile':
        case 'getmessage':
        case 'getobject':
        case 'getorganizationchart':
        case 'getruleset':
        case 'searchauditlog':
        case 'searchauditlogerror':
        case 'searchauditlogsecurity':
        case 'searchexporttemplate':
        case 'searchformtemplate':
        case 'searchgroupmember':
        case 'searchimporthrfile':
        case 'searchmessage':
        case 'searchobject':
        case 'searchobjecthistory':
        case 'searchruleset':
        case 'searchsystem':
            return {type: 'memory', duration: CACHE_DURATION_MEMORY};
        case 'getconditions':
        case 'getehubprocess':
        case 'getexportattributes':
        case 'getlanguages':
        case 'getmessagetypes':
        case 'getmessagevariables':
        case 'getobjecttypes':
        case 'getoperators':
        case 'getstatuscodes':
        case 'getsyncfields':
        case 'getsyncsteps':
        case 'getsyncstepstandardmappings':
        case 'getusernamegenerationrules':
        case 'getuserpasswordgenerationrules':
            return {type: 'persist', duration: CACHE_DURATION_PERSISTENT};
        default:
            return null as unknown as TServiceCache;
    }
}

export type TServiceDefinition = { name: TServiceName, paramKeys: readonly TServiceParameter[], cache: TServiceCache };
export type TServiceParameters = Partial<{ [k in TServiceParameter]: any }>

export type TServiceCache = { type: TCacheType, duration?: number };
export type TCacheType = "persist" | "memory";
